export default "__VITE_ASSET__DPouUHOq__"